import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../core/services/data/user.service';
import { OrderService } from '../../core/services/data/order.service';
import { ModalService } from '../../core/services/modal.service';
import { CartEvent } from '../../types/local';

export const VARIANT_CART_ITEM = 'cartItem';
export const VARIANT_CHECKOUT_ITEM = 'checkoutItem';
const VARIANTS = [
	VARIANT_CART_ITEM,
	VARIANT_CHECKOUT_ITEM,
];

@Component({
	selector: 'app-cart-event-nugget',
	templateUrl: './cart-event-nugget.component.html',
	styleUrls: ['./cart-event-nugget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CartEventNuggetComponent {
	public itemImage;

	public VARIANT_CART_ITEM = VARIANT_CART_ITEM;

	public VARIANT_CHECKOUT_ITEM = VARIANT_CHECKOUT_ITEM;

	public _variant = VARIANT_CART_ITEM;

	public detailsExpanded = false;

	public errorText;

	public event: CartEvent;

	public confirmText = 'Are you sure you want to remove event from your cart?';

	public buttonText = { confirm: 'Remove Event', cancel: 'Go Back' };

	public loading = false;

	@Input()
	set item(item) {
		if (item && item.item) {
			this.event = item.item;
		}
	}

	@Input()
	set variant(variant) {
		if (variant && VARIANTS.includes(variant)) {
			this._variant = variant;
		}
	}

	constructor(
		private os: OrderService,
		private ms: ModalService,
		private us: UserService,
		private router: Router,
	) { }

	get _id() {
		return this.event?._id;
	}

	get modalId() {
		return `remove-confirm-modal-${this._id}`;
	}

	get editLink() {
		if (this.us.me?.authorLink) {
			return `/author-dashboard/${this.us.me.authorLink}/events/${this.event._id}/edit`;
		}
		return `/events/${this.event._id}/edit`;
	}

	openConfirmationModal() {
		this.ms.open(this.modalId);
	}

	onEdit() {
		this.os.setCartNotVisible();
		this.router.navigate([this.editLink]);
	}

	onItemRemove(confirmed) {
		if (!confirmed) return;

		this.loading = true;
		this.os.removeItem(this._id).subscribe({
			next: () => {
				this.loading = false;
			},
			error: (error) => {
				this.loading = false;
				this.errorText = [`Uh oh, something went wrong. ${error}`];
				this.ms.open('cart-item-error-modal');
			},
		});
		this.ms.close(this.modalId);
	}
}
